export default "<div class=\"ball-clip-rotate gerando-excel\">\n  <div></div>\n  {{message}}\n</div>";